import { createContext } from 'react';

const snackbarContext = createContext();

export default snackbarContext;
